<script>
  import resources from './resources'

  export default {
    name: 'professional-schedulings-index',
    mixins: [resources],
    data () {
      return {
        date: new Date(),
        config: {
          locale: 'pt-br',
          format: 'DD/MM/YYYY',
          useCurrent: false,
          widgetPositioning: {
            horizontal: 'left',
            vertical: 'bottom'
          }
        }
      }
    }
  }
</script>

<template lang="pug">
  .col-xs-12.col-sm-9.col-md-10.content-wrapper
    modal(
      :visible="showModalCancel",
      name="schedule_canceled",
      height="auto",
      @close="hideShowModalCancel"
    )
      cancel(v-if="showModalCancel", :schedules="schedulesSelected", @close="onCloseCancel")
    modal(
      :visible="showModalReverser",
      :name="'schedule_reverser' + currentSchedule.id",
      height="auto",
      @close="hideShowModalReverser"
    )
      reverser(v-if="showModalReverser", :schedule="currentSchedule", @close="onCloseReverser")
    modal(
      :visible="showModalTransfer",
      :name="'schedule_transfer' + currentSchedule.id",
      height="auto",
      @close="hideShowModalTransfer"
    )
      transfer(v-if="showModalTransfer", :schedule="currentSchedule", @close="onCloseTransfer")
    .inner-title.two-lines
      h2
        span.first-line
          span.icon 
          |  Minha Agenda
        span.hifen  —
        span.second-line Lista de Agendamentos

    .col-xs-12.content
      div.hidden-md.hidden-lg
        br
        br
        router-link(:to="{name: 'patient.agendas.search'}")
          button.btn.btn-primary.zero-margin(type='button')
            span.icon 
            |  Novo Agendamento

      .container-fluid
        .row
          router-link.hidden-xs(:to="{name: 'patient.agendas.search'}", style="float: right")
            button.btn.btn-primary.zero-margin(type='button')
              span.icon 
              |  Novo Agendamento


          ul.nav.nav-tabs
              li
                router-link(:to="{ name: 'patient.agendas.schedulings'}")
                  | Agendados
              li.active
                a(href='#') Histórico
          .col-xs-12.white-bg
            .row
              .col-sm-12.p-t-15
                .col-xs-12.col-md-4.p-b-15
                    //--v-input(:status="$v.search.status.$error ? 'error' : null")
                    f-select(label="Status",
                      name="status",
                      :options="optionsStatus",
                      v-model="search.status")

                .col-xs-12.col-sm-3.margin-bottom
                  .input-group
                      //--v-input(:status="$v.search.date_start.$error ? 'error' : null")
                      label Data incial
                      v-datepicker(
                        v-model="search.date_start",
                        name="date_start",
                        :config='config')

                .col-xs-12.col-sm-3.margin-bottom
                  .input-group
                      //--v-input(:status="$v.search.date_end.$error ? 'error' : null")
                      label Data final
                      v-datepicker(
                        v-model="search.date_end",
                        name="date_end",
                        :config='config')

                .col-xs-12.col-sm-2.margin-bottom
                  button.btn.save-filled(@click.prevent="doLoadAll(true)", style='margin:20px;width:100%;')
                    span.icon 
                    | Localizar
              .col-xs-12.white-bg
                .row(v-if="loading")
                  spinner(:show="true")
                .row(v-if="!loading")
                  .agendamentos.col-xs-12.white-bg(v-if="schedules.length === 0")
                        h3
                          center.center Nenhum evento localizado.
                  .agendamentos.col-xs-12.white-bg(v-if="schedules.length >= 1")
                    .row.hidden-xs.hidden-sm
                      .col-xs-12.col-sm-1.col-title.active Data
                      .col-xs-12.col-sm-1.col-title Hora
                      .col-xs-12.col-sm-3.col-title Paciente
                      .col-xs-12.col-sm-3.col-title Profissional
                      .col-xs-12.col-sm-2.col-title Especialidade
                      .col-xs-12.col-sm-2.col-title.text-center Situação
                      //- .col-xs-12.col-sm-1.col-title.action-title Ação
                    .row
                      ul
                        schedule(v-for='schedule in schedules', :key='schedule.id', :schedule='schedule')
                    .row
                  .pagination
                    pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>
<style scped>
  h3 {
      text-align: center;
      font-size: 20px;
      font-weight: lighter;
      margin-top: 0;
      margin-bottom: 30px;
  }
  .center {
    text-align: center;
      font-size: 20px;
      font-weight: lighter;
      margin-top: 0;
      margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/app/patient/agendas/schedulings/history/index/index.vue